<template>
    <div class="new-chat">
        <input
            v-model="newThreadName"
            type="text"
            placeholder="Введите имя нового чата"
            class="chat-input"
            @keyup.enter="createThread"
        />
        <div @click="createThread" class="chat-button" :class="{ disabled: creating }" role="button" tabindex="0">
            <span class="icon">+</span>
        </div>
    </div>
</template>

<script>
import { yandexApi } from './api/yandex-api';
import Vue from 'vue';

export default {
    props: {
        onCreated: {
            required: true
        }
    },
    data() {
        return {
            newThreadName: '', // <-- новое поле для имени чата
            creating: false,
        };
    },
    methods: {
        async createThread() {
            if (this.creating) return;

            const userName = localStorage.getItem('USER_NAME');
            if (!userName) {
                console.error('Не удалось создать чат: USER_NAME отсутствует в localStorage');
                Vue.toasted.show('Не удалось создать чат: сессия пользователя не найдена. Перезагрузите страницу.', { type: 'error', duration: 5000 });
                return;
            }

            const threadName = this.newThreadName.trim() || 'Новый чат';

            const runBody = {
                userId: userName,
                name: threadName,
                description: "",
            };

            this.creating = true;
            try {
                const { data: thread } = await yandexApi.post(`/thread`, runBody);
                console.log('Чат создан:', thread);
                thread.processing = false;
                this.newThreadName = ''; // очистка поля после создания
                this.onCreated(thread);
            } catch (error) {
                console.error('Ошибка при создании чата:', error);
            } finally {
                this.creating = false;
            }
        },
    },
}
</script>

<style scoped>
.new-chat {
  display: flex;
  align-items: center;
  padding: 10px 3px 10px 3px;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.chat-input {
  flex: 1;
  min-width: 0; /* важно! чтобы не выталкивало кнопку */
  padding: 8px 8px 8px 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  box-sizing: border-box;
}

.chat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  background-color: #f15540;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  white-space: nowrap;
  height: 36px;
  width: 36px;
  box-sizing: border-box;
  flex: 0 0 auto;
  user-select: none;
  transition: background-color 0.2s;
}

.chat-button:hover {
  background-color: #d94a36;
}

.chat-button.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}

.icon {
  font-weight: bold;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/new-chat.vue